import { AttendanceProcedure } from "@/@types/esus/AttendanceProcedure";
import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizensProceduresIndicatorC3Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class DetailedCitizenProceduresIndicatorC3Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	dumDate: string = "";
	dppDate: string = "";
	gestationalAge?: number;
	inactivePregnancyDate?: string;
	pregnancyStatus: "pregnant" | "puerperal" | "finished" = "pregnant";
	firstTrimesterProcedures?: AttendanceProcedure[];
	firstTrimesterHivProceduresStatus: "finished" | "pending" | "lost" = "lost";
	firstTrimesterSifilisProceduresStatus: "finished" | "pending" | "lost" = "lost";
	firstTrimesterHepBProceduresStatus: "finished" | "pending" | "lost" = "lost";
	firstTrimesterHepCProceduresStatus: "finished" | "pending" | "lost" = "lost";
	firstTrimesterProceduresStatus: "finished" | "pending" | "lost" = "lost";
	thirdTrimesterProcedures?: AttendanceProcedure[];
	thirdTrimesterHivProceduresStatus: "finished" | "pending" | "lost" = "lost";
	thirdTrimesterSifilisProceduresStatus: "finished" | "pending" | "lost" = "lost";
	thirdTrimesterProceduresStatus: "finished" | "pending" | "lost" = "lost";
}

export async function getDetailedCitizensProceduresIndicatorC3({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensProceduresIndicatorC3Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenProceduresIndicatorC3Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c3/detailed-citizens-procedures`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenProceduresIndicatorC3Data>();
}
